import CryptoJS from "crypto-js";

const encrypt = process.env.REACT_APP_ENCRYPT;
const encryptionKeyHex = process.env.REACT_APP_ENCRYPTION_KEY;
const encryptionKey = CryptoJS.enc.Hex.parse(encryptionKeyHex);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

export const encryptValue = (value) => {
  try {
    if (encrypt === "false") return value;
    if (typeof value !== "string") return value;

    const encrypted = CryptoJS.AES.encrypt(value, encryptionKey, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return `ENC::${encrypted.toString()}`;
  } catch (error) {
    console.error("Erro ao criptografar campo:", error, value);
    return value;
  }
};
